// Module-level so the identity is stable across renders and the context value never changes.
const noopKameleoon = Object.freeze({
    assignedVariantByExperimentId: () => undefined,
    trackConversion: () => { },
});
export { noopKameleoon };
